import { styled } from "styled-components";


export const Container = styled.div`
width:100vw;
height:100vh;
display:flex;
 justify-content:center;

.welcome-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    margin-top: 1rem; /* Espaçamento adicional entre a imagem e o texto */
}
 

.logo{
 width:60px;
 height:60px;
 object-fit:cover;
 border-radius:0.6rem;

}
.container-image{
    align-items:center;
    display:flex;
    justify-content:center;
}
.container-left{
 width: 50vw;
 height:100vh;
  background-color: #DB6015;
  img{
  width:100%;
  height:100vh;
  object-fit:cover;
  }
}

@media screen and (max-width:768px){
.container-left{
display:none;
}
}

`

export const Content = styled.div`
 background-color: #d9d8d6;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
border-radius:0.5rem;
width:50vw;

.header{
   h1{
    text-align:center;
    font-size:1.2rem;
   } 
   h2{
    text-align:center;
    font-size:1rem;
    font-weight:400;
   }
}
@media screen and (max-width:768px){
width:100vw;
}

@media screen and (max-width:430px){
    width:20rem;
    height:25rem;
    align-items:center;
    input{
      width:  15rem;
     }
    
}
`


export const Form = styled.div`

form {
    display:flex;
    flex-direction:column;
    gap:2rem;

}
button{
    background-color:#DB6015;
    border:none;
    padding:0.8rem;
    width:15rem;
    border-radius:0.5rem;
    color:white;
    font-size:1rem;
    cursor:pointer;
    transition:0.3s;
}
.button:hover{
opacity:0.8;
}
.remenber{
    margin-top:-2rem;
    align-items:center;
    display:flex;
    label{
        font-size:0.8rem;
    }
}
@media screen and (max-width:430px){
 button{
    width:10rem;
 }

    
}
`
export const ContainerInput = styled.div`
display:flex;
flex-direction:column;

.icon{
    display:flex;
    align-items:center;
    justify-content:center;
    position:relative;
    svg{
        position:absolute; 
        right:1rem;
    }
   
} 
`


export const Label = styled.label`

font-size:0.8rem;
margin-bottom:0.2rem;


`

export const Input = styled.input`
outline:none;
width:20rem;
height:2.5rem;
padding:1rem;
border-radius:0.5rem;
border:none;
transition :0.2s ease-in-out ;
background-color:white;
&:focus {
  border: 1px solid #ffe0b5;
}



`

